import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useTranslations } from "next-intl";
interface Feature {
  featureKey: string;
  featureValue: string;
  title: string | null;
  unit: string | null;
  parentKey: string | null;
}
interface Props {
  features: Feature[];
}
function groupByParentKey(features: Feature[]) {
  return features.reduce<Record<string, Feature[]>>((acc, feature) => {
    const key = feature.parentKey || "Outros";
    if (!acc[key]) acc[key] = [];
    acc[key].push(feature);
    return acc;
  }, {});
}
function normalizeGroupKey(key: string): string {
  return key.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/\s+/g, "_");
}
const RealEstateFeaturesCards: React.FC<Props> = t0 => {
  const $ = _c(17);
  const {
    features
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== features || $[1] !== t) {
    const grouped = groupByParentKey(features);
    const groupEntries = Object.entries(grouped).filter(_temp);
    t4 = "RealEstateFeaturesCards";
    t5 = "RealEstateFeaturesCards.tsx";
    t3 = "pb-4 md:pb-8";
    t1 = "columns-1 md:columns-3 md:gap-20 gap-8";
    t2 = groupEntries.map(t6 => {
      const [parentKey_0, group] = t6;
      return <div key={parentKey_0} className="relative mb-8 break-inside-avoid"><div className="font-semibold text-base md:text-lg text-foreground-heading mb-4">{t.has(`featureGroups.${normalizeGroupKey(parentKey_0)}`) ? t(`featureGroups.${normalizeGroupKey(parentKey_0)}`) : parentKey_0}</div><ul className="space-y-2">{group.map(_temp2)}</ul></div>;
    });
    $[0] = features;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className={t3}>{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div data-sentry-component={t4} data-sentry-source-file={t5}>{t7}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default RealEstateFeaturesCards;
function _temp(t0) {
  const [parentKey] = t0;
  const normalized = parentKey.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
  return normalized !== "outros" && normalized !== "areas";
}
function _temp2(feature, idx) {
  return <li key={feature.featureKey + idx} className="flex gap-8 items-center justify-between text-sm md:text-base"><span className="text-foreground-strong">{feature.title || feature.featureKey}</span>{feature.featureValue && feature.featureValue !== "0" && <span className="text-foreground font-medium"><span className="font-light">{feature.featureValue}</span>{feature.unit ? <span className="text-foreground">{` ${feature.unit}`}</span> : ""}</span>}</li>;
}